import styled from 'styled-components';

export const ClickTopBarContainer = styled.div(({ theme }) =>
  theme.withMedia({
    background: theme.styleguideColors.backgroundTertiary,
    width: '100%',
    maxWidth: 1176,
    margin: '0 auto',
    padding: ['0px 16px', '0px 32px', '0px 56px', '0px'],
  })
);
